import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';

export const Architect: React.FC = () => (
  <section className={cx('main_section_architector')}>
    <div className={cx('padding-global padding-section-medium')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_architector')}>
          <div className={cx('main_architector_content-grid')}>
            <h2 className={cx('text-size-xhuge')}>
              {'Будь '}
              <span className={cx('text-color-brand-green')}>{'архитектором'}</span>
              {', а не '}
              <br />
              {'наблюдателем'}
            </h2>
            <div className={cx('main_architector_right')}>
              <div className={cx('main_architector_text-item')}>
                <h3>{'Катализируй это'}</h3>
                <p className={cx('main_architector_text')}>
                  {'Люди в Циане позволяют себе верить, мечтать и менять статус-кво. '}
                </p>
              </div>
              <div className={cx('main_architector_text-item')}>
                <h3>{'Будь «площе»'}</h3>
                <p className={cx('main_architector_text')}>
                  {'Дистанция между гендиром и младшим специалистом короче, чем в обычном корпорате.'}
                </p>
              </div>
              <div className={cx('main_architector_text-item')}>
                <h3>{'Бери и делай'}</h3>
                <p className={cx('main_architector_text')}>{'Придумал проект и готов его реализовать? Пожалуйста.'}</p>
              </div>
              <div className={cx('main_architector_text-item')}>
                <h3>
                  {'Ошибайся '}
                  <br />
                  {'быстрее'}
                </h3>
                <p className={cx('main_architector_text')}>
                  {'Каждый волен ставить эксперименты и проверять свои гипотезы.'}
                </p>
              </div>
              <div className={cx('main_architector_text-item')}>
                <h3>
                  {'Адаптируйся '}
                  <br />
                  {'и побеждай'}
                </h3>
                <p className={cx('main_architector_text')}>
                  {'Пандемия, взлёт ключевой ставки, конец льготной ипотеки? '}
                  <br />
                  {'Гибкость — сестра таланта. '}
                </p>
              </div>
              <div className={cx('spacer-medium')}></div>
              <a
                href="https://hr.cian.tech/leadership-principles#rec806038332"
                rel="noopener noreferrer"
                target="_blank"
                className={cx('button is-medium is-blue-on-white max-width-full w-button')}
              >
                {'Узнать больше'}
              </a>
            </div>
          </div>
          <div className={cx('spacer-large')}></div>
          <div className={cx('main_architector_image-wrapper')}>
            <img
              src={media.mainArchitectorCardImage}
              loading="lazy"
              sizes="100vw"
              srcSet={[
                media.mainArchitectorCardImageP500 + ' 500w',
                media.mainArchitectorCardImageP800 + ' 800w',
                media.mainArchitectorCardImageP1080 + ' 1080w',
                media.mainArchitectorCardImageP1600 + ' 1600w',
                media.mainArchitectorCardImage + ' 1731w',
              ].join(', ')}
              alt=""
              className={cx('main_architector_card-girl-image')}
            />
            <img
              src={media.mainArchitectorCardPuzzleImage}
              loading="lazy"
              sizes="100vw"
              srcSet={[
                media.mainArchitectorCardPuzzleImageP500 + ' 500w',
                media.mainArchitectorCardPuzzleImageP800 + ' 800w',
                media.mainArchitectorCardPuzzleImageP1080 + ' 1080w',
                media.mainArchitectorCardPuzzleImage + ' 1440w',
              ].join(', ')}
              alt=""
              className={cx('main_architector_card-puzzle-image')}
            />
            <div className={cx('main_architector_bottom-card')}>
              <div className={cx('main_architector_bottom-card-left-wrapper')}>
                <h3 className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>
                  {'Как строились наши стены'}
                </h3>
              </div>
              <div className={cx('main_architector_bottom-card-rigth-wrapper')}>
                <div>
                  {
                    'Мы не сразу стали такими, какие есть. Это была череда экспериментов, больших открытий и трудных решений, которые год за годом формировали нашу среду.'
                  }
                </div>
                <div className={cx('spacer-medium')}></div>
                <a
                  href="https://hr.cian.tech/stories_cian"
                  rel="noopener noreferrer"
                  target="_blank"
                  className={cx('button is-white-on-blue w-button')}
                >
                  {'Погрузиться в историю'}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
